<template>
  <!-- <tab-content title="Select Employees" class="mb-5" :before-change="validateStep2"> -->

  <!-- <div :class="createPayroll.createPayrollTypeId === 2 ? 'vx-row pointer-events-none' : 'vx-row'" > -->
  <div v-if="createPayroll != null" class="vx-row">
    <vx-card title="Select Employees">
      <div v-if="isMultipleSelectionAllowed" class="select-all">
        <input
          type="checkbox"
          :checked="isAllSelected"
          @change="toggleSelectAll"
        />
        Select All
      </div>
      <vs-table
        :data="getAllEmployeeByStatus"
        v-model="selected"
        @selected="onAllEmployeeByStatus"
        :multiple="isMultipleSelectionAllowed"
        stripe
        pagination
        :max-items="10"
        search
      >
        <template slot="thead">
          <vs-th>Code</vs-th>
          <vs-th>Name</vs-th>
          <vs-th>Employee Status</vs-th>
          <vs-th>Employment Status</vs-th>
          <vs-th>Date Start</vs-th>
          <vs-th>Date Resigned</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].employeeCode">
              {{ data[indextr].employeeCode }}
            </vs-td>
            <vs-td :data="data[indextr].fullName">
              {{ data[indextr].fullName }}
            </vs-td>
            <vs-td :data="data[indextr].employeeInformation.employeeStatus">
              {{
                empStatusName(data[indextr].employeeInformation.employeeStatus)
                  .status
              }}
            </vs-td>
            <vs-td :data="data[indextr].employeeInformation.employmentStatus">
              {{
                employStatusName(
                  data[indextr].employeeInformation.employmentStatus
                ).employStatus
              }}
            </vs-td>
            <vs-td :data="data[indextr].employeeInformation.dateStart">
              {{ data[indextr].employeeInformation.dateStart | fulldate }}
            </vs-td>
            <vs-td :data="data[indextr].employeeInformation.dateResigned">
              {{ data[indextr].employeeInformation.dateResigned | fulldate }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
  <!-- </tab-content> -->
</template>
<script>
export default {
  props: {
    createPayroll: {
      type: Object,
      required: false,
    },
    isValidate2: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  watch: {
    isValidate2(value) {
      if (value) this.onGetAllEmployeeByStatus();
    },
  },
  computed: {
    getAllEmployeeByStatus() {
      return this.$store.state.employeesToProcess;
    },
    empStatusName() {
      return (id) => this.$store.getters["lookup/empStatus"](id);
    },
    employStatusName() {
      return (id) => this.$store.getters["lookup/employStatus"](id);
    },
    isAllSelected() {
      return this.selected.length === this.getAllEmployeeByStatus.length;
    },
    isMultipleSelectionAllowed() {
      return !(
        this.createPayroll.createPayrollTypeId === 1 ||
        this.createPayroll.createPayrollTypeId === 2 ||
        this.createPayroll.createPayrollTypeId === 5
      );
    },
  },
  methods: {
    onGetAllEmployeeByStatus() {
      if (this.createPayroll != null) {
        console.log(this.createPayroll);
        const selectedEmployees = this.$store.getters[
          "hrms/getAllEmployeeByStatus"
        ](
          this.createPayroll.createPayrollTypeId,
          this.createPayroll.paymentModeId
        );

        console.log("SELECTEDEMPLOYEES");
        console.log(selectedEmployees);
        if (
          this.createPayroll.createPayrollTypeId <= 2 ||
          this.createPayroll.createPayrollTypeId == 5
        )
          this.$store.commit("SELECTEDEMPLOYEES", selectedEmployees);
        else this.selected = [];
        this.$store.commit("EMPLOYEESTOPROCESS", selectedEmployees);
      }
    },
    onAllEmployeeByStatus() {
      console.log("SELECTED");
      console.log(this.selected);
      this.$store.commit("SELECTEDEMPLOYEES", this.selected);
      // this.$emit('selected-employees', this.selected)
    },

    toggleSelectAll(event) {
      const isChecked = event.target.checked;
      console.log("Toggle Select All:", isChecked);

      if (isChecked) {
        // Select all employees
        this.selected = this.getAllEmployeeByStatus; // Assuming employeeCode is unique
        this.$store.commit("SELECTEDEMPLOYEES", this.selected);
        console.log("Selected Employees:", this.selected);
      } else {
        // Deselect all employees
        this.selected = [];
        console.log("Selected Employees Cleared:", this.selected);
      }
    },
  },
};
</script>
